import React, { Component } from 'react';
import { connect } from 'react-redux';
import POISection from './POISection';
import RatingBumpsSection from './RatingBumps';
import NewProspectsSection from './NewProspects';
import TrackedProspectsSection from './TrackedProspects';

class ProspectIdentification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      poi: [],
      ratingBump: [],
      newPropsect: [],
      tracked: [],
    };
  }

  componentWillMount() {
    this.separateFilters(this.props.displayedUser);
  }
  componentWillReceiveProps(nextProps) {
    this.separateFilters(nextProps.displayedUser);
  }

  separateFilters(user) {
    this.setState({
      poi: this.getFilters(user.filters, 'poi'),
      ratingBump: this.getFilters(user.filters, 'ratingBump'),
      newPropsect: this.getFilters(user.filters, 'newProspect'),
      tracked: this.getFilters(user.filters, 'trackedProspect'),
    });
  }

  getFilters(filters, type) {
    if (!filters) return [];
    return filters.filter((filter) => {
      return filter.filterCategory.name === type;
    });
  }

  render() {
    return (
      <div>
        {!this.props.organization.package.is_zmail && (
          <TrackedProspectsSection filters={this.state.tracked} />
        )}
        <POISection filters={this.state.poi} />
        <RatingBumpsSection filters={this.state.ratingBump} />
        <NewProspectsSection filters={this.state.newPropsect} />
      </div>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    displayedUser: storeState.main.displayedUser,
    redirected: storeState.main.redirected,
    organization: storeState.main.organization,
  };
}

export default connect(mapStoreToProps)(ProspectIdentification);



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/ProspectIdentification.js